import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { LiveSearchSearchableKeywords } from './live-search.types';
import { LiveSearchGeneralSection } from '@nirvana/shared/dtos/types/policies/common';

export const LIVE_SEARCH_DEFAULT_VALUE: LiveSearchGeneralSection = {
  enabled: false,
};

export function getLiveSearchSearchableKeywords(): {
  [type in LiveSearchSearchableKeywords]: SearchableKeyword;
} {
  return {
    [LiveSearchSearchableKeywords.LiveSearch]: {
      translatedLabel: translateFn('Live Search'),
      label: 'Live Search',
    },
  };
}
